var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-text-editor",class:{ disabled: _vm.data.disabled }},[_c('textarea',{attrs:{"id":_vm.inputFieldId,"name":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }